import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as colors from '#app/constants/Color';
import styles from './Icon.scss';

// eslint-disable-next-line import/namespace
const colorMap = [null].concat(Object.keys(colors).map((key) => colors[key]));

const Icon = ({
  icon = null,
  size = null,
  color = null,
  className = '',
  circle = null,
  align = null,
  children = null,
  ...props
}) => (
  <span
    {...props}
    className={classnames('icon', styles.icon, className, {
      [`is-${size}`]: size,
      [`is-${align}`]: align,
      [`is-circle`]: circle,
      [`has-text-${color}`]: color,
    })}
  >
    {children || (
      <i
        className={classnames(
          icon && icon.includes('fa-') ? 'rbc' : 'icomoon',
          icon,
        )}
      />
    )}
  </span>
);

Icon.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  circle: PropTypes.string,
  style: PropTypes.shape({}),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  align: PropTypes.oneOf(['left', 'right']),
  color: PropTypes.oneOf(colorMap),
};

export default Icon;
